const api = process.env.REACT_APP_API_URL;

function fetchQuery(query, params) {
  const search = `?query=${encodeURIComponent(query)}`;
  const paramsSearch = params ? `&params=${encodeURIComponent(JSON.stringify(params))}` : '';

  return fetch(`${api}${search}${paramsSearch}`).then((payload) => payload.json());
}

export function sanity_categories() {
  const query = `*[_type=="category" && path.current match "group_*"] | order(path.current asc)
    { _id, title, machineName,
      "bg":"https://cmsassets.rgpub.io/sanity/"+backdrop.backgroundMedia.sanityImage.asset->path,
      "logo":"https://cmsassets.rgpub.io/sanity/"+backdrop.backgroundMedia.thumbnail.sanityImage.asset->path,
      "legals":
        *[_type=="category" && machineName match ^.machineName+"*" &&  !(path.current match "group_*")] | order(machineName)
        {title, externalTitle, machineName, _id, product, category, "path":path.current}
    }`;

  return fetchQuery(query);
}

export function sanity_all_categories() {
  return fetchQuery(`*[_type=="category"].path.current`);
}

const subquery = ` | order(publishingDates.displayedPublishDate desc) {
      _id, "title":externalTitle, "body": contentBlocks[0].richText.bodyHtml,
      "category":*[_type=="category" && _id == ^.category._ref][0]{title,"path":path.current,"bg":"https://cmsassets.rgpub.io/sanity/"+backdrop.media.sanityImage.asset->path},
      "displayedPublishDate":publishingDates.displayedPublishDate,
      "path":path.current,
      "versions": *[_type=="article" && category._ref == ^.category._ref] | order(publishingDates.displayedPublishDate desc) {_id, "displayedPublishDate":publishingDates.displayedPublishDate}
    }`;

export function sanity_articleById(id) {
  const query = `*[_type=="article"  && _id match $idPattern]  ${subquery}`;

  return fetchQuery(query, { idPattern: `*${id}*` });
}

export function sanity_articleByPathname(pathname) {
  const query = `*[_type=="article"  && path.current == $pathname]  ${subquery}`;

  return fetchQuery(query, { pathname });
}

export function sanity_articleByCategoryPathname(pathname) {
  const query = `*[_type=="article"  &&
    category._ref in *[_type=="category" &&
    $pathname == path.current]._id && (publishingDates.displayedPublishDate <= now() || publishingDates.displayedPublishDate == null)] ${subquery}`;

  return fetchQuery(query, { pathname });
}
